module.exports = __webpack_public_path__ + "static/media/nien-nunb.ed1fe054.jpg";